export const AGENT_ID = {
    manage: "uk7bj.java.toca.space.backend",
    file: "uk7bj.java.toca.file",
    wiki: "uk7bj.toca.tiptab.backend",
    aichat: "uk7bj.java.toca.ai.chat",
    openDeveloper: "uk7bj.java.toca.app.mng",
    cloudHome: "uk7bj.java.toca.cloud.home",
    tem: "uk7bj.java.toca.file.template.backend"
};

export const WEB_PATH = {
    fe: "/fe",
    file: "/web/file#",
    cloud: "/cloud",
    aichat: "/chat",
    openDeveloper: "/opendeveloper",
    tem: "/tem"
};

export const CLIENT_ENUM = ["WEB", "TOCA_PC"];

export const HASH_QUERY = ["file"];

const cookieOperator = () => {
    const env = process.env.VUE_APP_STATIC_NODE_ENV;
    switch (env) {
        case "production":
            return [
                { path: "/", domain: ".17u.cn", expires: 60 },
                { path: "/", domain: ".17usoft.com", expires: 60 }
            ];
        case "development":
            return [
                { path: "/", domain: ".qa.17u.cn", expires: 60 },
                { path: "/", domain: ".qa.17usoft.com", expires: 60 }
            ];
        case "qa":
            return [
                { path: "/", domain: ".qa.17u.cn", expires: 60 },
                { path: "/", domain: ".qa.17usoft.com", expires: 60 }
            ];
        case "stage":
            return [
                { path: "/", domain: ".t.17u.cn", expires: 60 },
                { path: "/", domain: ".t.17usoft.com", expires: 60 }
            ];
        default:
            return [
                { path: "/", domain: ".qa.17u.cn", expires: 60 },
                { path: "/", domain: ".qa.17usoft.com", expires: 60 }
            ];
    }
};

export const cookieOptions = cookieOperator();
